import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/img/triangle-left.png'
import _imports_1 from '../../../public/images/img/triangle-right.png'
import _imports_2 from '../../../public/images/triangle_about_top.png'


const _withScopeId = n => (_pushScopeId("data-v-0e31b0d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container mediabuying-section-wrapper" }
const _hoisted_3 = { style: {"position":"relative"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decor_left",
  src: _imports_0,
  alt: "triangle decor"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decor_right",
  src: _imports_1,
  alt: "triangle decor"
}, null, -1))
const _hoisted_6 = { class: "title__wrapper" }
const _hoisted_7 = { class: "mediabuying-section-title pos" }
const _hoisted_8 = { class: "mediabuying-section-subtitle pos" }
const _hoisted_9 = { class: "list pos" }
const _hoisted_10 = {
  style: {"display":"block"},
  class: "item item__main item__about"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decor",
  src: _imports_2,
  alt: "triangle"
}, null, -1))
const _hoisted_12 = { class: "about" }
const _hoisted_13 = { class: "infra" }
const _hoisted_14 = { class: "roi" }
const _hoisted_15 = { class: "item item__accent" }
const _hoisted_16 = { class: "item item__main" }
const _hoisted_17 = { class: "item item__main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.title')), 1),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.subtitle')), 1)
          ]),
          _createVNode(_component_Button, {
            style: {"display":"flex"},
            class: "pos",
            outlined: "",
            onClick: this.onClickReg,
            text: _ctx.$t('btn.join')
          }, null, 8, ["onClick", "text"])
        ]),
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.nas')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.infra')), 1),
              _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.infra_text')), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.best')), 1)
          ]),
          _createElementVNode("li", _hoisted_16, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.traf')), 1)
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.partners')), 1)
          ]),
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openExternalSite('https://t.me/MT_SHOP_Support'))),
            class: "item item__main advatages__hovered"
          }, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.shop')), 1)
          ]),
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openExternalSite('https://t.me/agency_mt'))),
            class: "item item__black advatages__hovered"
          }, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.agency')), 1)
          ]),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openExternalSite('https://t.me/Masons_App'))),
            class: "item item__main advatages__hovered"
          }, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.app')), 1)
          ]),
          _createElementVNode("li", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openExternalSite('https://t.me/creogamble'))),
            class: "item item__accent advatages__hovered"
          }, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('mediaBuying.newadvantages.click')), 1)
          ])
        ])
      ])
    ])
  ]))
}